// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import MenuCard from "../MenuCard";
// import './listItem.css'
// import VegIcon from "../../Assets/vegIcon.png"
// import NonVegIcon from "../../Assets/nonVegIcon.png"
// import { diet } from "../../Utills/enums";

// // 1. 🌟 UPDATED: Received tableName as a prop here
// const ListItem = ({ category, tableName, showNote=false, ActionComponent = () => { } }) => {
  
//   // 2. 🌟 UPDATED: Extracted specific table's cart from state
//   const fullCartState = useSelector((state) => state?.user?.cart);
//   const cart = fullCartState?.[tableName] || {}; 

//   const [selectedSizes, setSelectedSizes] = useState({}); 

//   if (!category) {
//     return <p>No category found.</p>;     
//   }

//   const items = Array.isArray(category.items) ? category.items : [];

//   if (items.length === 0) {
//     return <p>No menu items found.</p>;
//   }

//   const handleSizeSelect = (menuId, size) => {
//     setSelectedSizes(prev => ({
//       ...prev,
//       [menuId]: size
//     }));
//   };

//   const getDisplayPrice = (item) => {
//     const selectedSize = selectedSizes[item.menuId];
//     if (selectedSize) {
//       return selectedSize.price;
//     }
//     return item.price;
//   };

//   // 3. 🌟 UPDATED: Now looks inside the selected table's cart object
//   const getCartUnit = (item) => {
//     const selectedSize = selectedSizes[item.menuId];
//     if (selectedSize) {
//       const cartKey = `${item.menuId}_${selectedSize.sizeOptionId}`;
//       return cart[cartKey];
//     }
//     return cart[item.menuId];
//   };

//   console.log("menu", items)
//   return (
//     <div className="order-boxes-grid">
//       {category?.items.map((val, index) =>
//         <div
//           key={val.menuId}
//           className={val.isAvailable ? 'order-box' : 'order-box over'}
//         >
//           <div className="item-name" style={{ display: "flex", alignItems: "center", gap: "8px" }} >
//             <img src={diet[val.foodTypeId] === 'Veg' || diet[val.foodTypeId] === 'Vegan' ? VegIcon : NonVegIcon} title="" alt="" className="diet-img" />
//             <span>{val.foodName}</span>
//           </div>

//           <div className="order-price">₹ {getDisplayPrice(val)}</div>
//           {ActionComponent &&
//             <div className="order-menuSelectItem">
//               {/* 4. 🌟 UPDATED: Passed tableName in ActionComponent so it can dispatch with tableName */}
//               <ActionComponent 
//                 menuId={val.menuId} 
//                 unit={getCartUnit(val)}
//                 tab={category?.categoryId} 
//                 isAvailable={val.isAvailable}
//                 menuSizeOptions={val.menuSizeOptions}
//                 onSizeSelect={(size) => handleSizeSelect(val.menuId, size)}
//                 selectedSize={selectedSizes[val.menuId]}
//                 showNote={showNote}
//                 tableName={tableName} 
//               />
//             </div>}
//         </div>
//       )}
//     </div>
//   )
// }

// export default ListItem;


import React, { useState } from "react";
import { useSelector } from "react-redux";
import './listItem.css';
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import { diet } from "../../Utills/enums";
import { isOrderAvailable } from "../../Utills/menuAvailability";
import EmptyScreen from "../common/EmptyScreen";

const ListItem = ({ category, tableName, showNote = false, ActionComponent = () => { }, respectSchedule = false }) => {
  const fullCartState = useSelector((state) => state?.user?.cart);
  const cart = fullCartState?.[tableName] || {}; 

  const [selectedSizes, setSelectedSizes] = useState({}); 

  if (!category) return <EmptyScreen compact message="Category unavailable." subText="Choose another category to continue." />;

  const items = Array.isArray(category.items) ? category.items : [];
  if (items.length === 0) return <EmptyScreen compact message="No menu items available." subText="Items added to this category will appear here." />;

  const handleSizeSelect = (menuId, size) => {
    setSelectedSizes(prev => ({
      ...prev,
      [menuId]: size
    }));
  };

  // const getDisplayPrice = (item) => {
  //   const selectedSize = selectedSizes[item.menuId];
  //   if (selectedSize) {
  //     return selectedSize.price;
  //   }
  //   return item.price;
  // };

  const getDisplayPrice = (item) => {
    // 1. Agar user ne specifically size select kiya ho toh wahi dikhe
    const selectedSize = selectedSizes[item.menuId];
    if (selectedSize && selectedSize.price) {
      return selectedSize.price;
    }

    // 2. ⭐ Agar item ke multiple sizes hain, toh sabse lowest (lesser) price nikaalein
    if (Array.isArray(item.menuSizeOptions) && item.menuSizeOptions.length > 0) {
      const validPrices = item.menuSizeOptions
        .map(opt => Number(opt.price))
        .filter(price => !isNaN(price) && price > 0);

      if (validPrices.length > 0) {
        return Math.min(...validPrices); // e.g. ₹343 aur ₹34 me se ₹34
      }
    }

    // 3. Normal item ke liye direct price
    return item.price || 0;
  };



  // ⭐ FIX: Composite key ya plain menuId se matches dhoondhein aur total count calculate karein
  const getCartUnit = (item) => {
    const matchingEntries = Object.values(cart).filter(
      (c) => c.menuId === item.menuId
    );

    if (matchingEntries.length === 0) return null;

    // Total quantity of this dish in cart
    const totalSelected = matchingEntries.reduce((sum, c) => sum + (c.selected || 0), 0);
    
    return {
      ...matchingEntries[matchingEntries.length - 1], // latest config reference
      selected: totalSelected,
      matchingCount: matchingEntries.length,
      allConfigs: matchingEntries
    };
  };

  return (
    <div className="order-boxes-grid">
      {category?.items.map((val) => (
        <div
          key={val.menuId}
          className={(respectSchedule ? isOrderAvailable(val) : val.isAvailable) ? 'order-box' : 'order-box over'}
        >
          <div className="item-name" style={{ display: "flex", alignItems: "center", gap: "8px" }} >
            <img 
              src={diet[val.foodTypeId] === 'Veg' || diet[val.foodTypeId] === 'Vegan' ? VegIcon : NonVegIcon} 
              alt="" 
              className="diet-img" 
            />
            <span>{val.foodName}</span>
          </div>

          <div className="order-price">₹ {getDisplayPrice(val)}</div>
          
          {ActionComponent && (
            <div className="order-menuSelectItem">
              <ActionComponent 
                menuId={val.menuId} 
                unit={getCartUnit(val)}
                tab={category?.categoryId} 
                isAvailable={respectSchedule ? isOrderAvailable(val) : val.isAvailable}
                respectSchedule={respectSchedule}
                menuSizeOptions={val.menuSizeOptions}
                onSizeSelect={(size) => handleSizeSelect(val.menuId, size)}
                selectedSize={selectedSizes[val.menuId]}
                showNote={showNote}
                tableName={tableName} 
                rawItem={val} // ⭐ Pass raw item
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ListItem;
